import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import Teammates from 'app/scripts/components/common/users';
import AssignBlacklist from 'app/scripts/components/common/inputs/user-assignment';
import { fetchBlockedUsers } from '../state/actions/fetch-users';
import { TModerationUser } from '../state/types';
import { getUsersOfType } from '../state/reducer';
import { removeBlockedUser } from '../state/actions/remove-user';

const SCROLL_EDGE_TRESHOLD = 200;

const mapDispatchToProps = dispatch => ({
  fetchBlockedUsers: (props = {}) => {
    dispatch(fetchBlockedUsers(props));
  },
  addBlockedUser: props => {
    dispatch(addBlockedUser(props));
  },
  removeBlockedUser: props => {
    dispatch(removeBlockedUser(props));
  }
});

const mapStateToProps = state => getUsersOfType(state, TModerationUser.BlockedUsers);

class BlacklistedUsers extends Component {
  static displayName = 'BlacklistedUsers';

  static propTypes = {
    spotId: PropTypes.string.isRequired,
    users: PropTypes.array,
    isLoading: PropTypes.bool,
    totalUsers: PropTypes.number,
    fetchBlockedUsers: PropTypes.func,
    addBlockedUser: PropTypes.func,
    removeBlockedUser: PropTypes.func,
    isViewOnlyMode: PropTypes.bool
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      searchUserBy: 'username',
      tooltipVisible: false,
      placeholder: 'Type usename',
      resetValue: false
    };
  }

  componentDidMount() {
    this.props.fetchBlockedUsers();
  }

  loadNextPage() {
    var { isLoading, totalUsers, users } = this.props;
    if (!isLoading && users.length < totalUsers) {
      this.props.fetchBlockedUsers({
        offset: users ? users.length : 0
      });
    }
  }

  @autobind
  handleScroll() {
    let blacklist = document.querySelector('.teammates-users');
    var scrollFromTop = blacklist.scrollTop;
    var scrollFromBottom = blacklist.scrollHeight - scrollFromTop - blacklist.clientHeight;
    if (scrollFromBottom <= SCROLL_EDGE_TRESHOLD) {
      this.loadNextPage();
    }
  }

  @autobind
  onSearchTypeChange(type) {
    let placeholder = 'Type username...';
    if (type === 'email') {
      placeholder = 'Enter user email (exact match)';
    }
    this.setState({ searchUserBy: type, placeholder });
  }

  @autobind
  resetSearch() {
    this.setState({ resetValue: true });
  }

  @autobind
  onResetDone() {
    this.setState({ resetValue: false });
  }

  render() {
    let { users, spotId, spot, addBlockedUser, removeBlockedUser, isViewOnlyMode } = this.props;
    let { searchUserBy, placeholder, resetValue } = this.state;

    return (
      <div className="blacklisted">
        <AssignBlacklist
          onResetDone={this.onResetDone}
          resetValue={resetValue}
          resetSearch={this.resetSearch}
          className="moderation-users"
          description="Comments by these users on your site will be automatically rejected."
          teammates={users}
          type="blacklist"
          spotId={spotId}
          onSearchTypeChange={this.onSearchTypeChange}
          searchUserBy={searchUserBy}
          placeholder={placeholder}
          isViewOnlyMode={isViewOnlyMode}
        />
        <Teammates
          onScroll={this.handleScroll}
          spot={spot}
          users={users}
          addUser={addBlockedUser}
          removeUser={removeBlockedUser}
          type="blacklist"
          isViewOnlyMode={isViewOnlyMode}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlacklistedUsers);
